/**
 * Create Meta Definitions context for custom hook
 */
import { createContext } from 'react'

const MetaDefinitionsContext = createContext({
  fetchMetaDefinitions: () => {},
  // // TODO: will implement when need to use
  // getMetaDefinitionDynamicOptions: () => {}
})

export default MetaDefinitionsContext
